// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2JTFh","boxTitle":"Qualiphy_boxTitle__qFRpv","box":"Qualiphy_box__2t_aF","toggleWrap":"Qualiphy_toggleWrap__1BzgJ"};